<template>
  <v-card style="min-width: 400px">
    <v-toolbar
      class="white--text"
      color="indigo"
      dense
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title dense>
        Avanzamento Alternativo Contenitore
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="showPreviewEtichetta"
            class="mr-5"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-printer </v-icon>
          </v-btn>
        </template>
        <span>Stampa Etichetta</span>
      </v-tooltip>

      <!-- Finto bottone del reader, che esegue la validazione e
           se serve innesca il metodo dentro il vero reader. -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            bottom
            small
            @click="handleDataMatrixClick"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-qrcode</v-icon>
          </v-btn>
        </template>
        <span>Scansiona il QR CODE</span>
      </v-tooltip>

      <DataMatrixReader
        ref="qr"
        @clickChiudi="qr_attivo = false"
        v-on:detectQrCode="detectQrCode"
        v-show="false"
      />

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="red--text"
            @click="clickChiudi"
            color="blue-grey lighten-5"
            small
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-10">
      <v-row align="center" justify="center">
        <!-- Spazio per il codice articolo -->
        <v-col cols="6">
          <!-- <v-autocomplete
            class="centered-input"
            @change="
              setCodEtichette();
              setCodArticolo();
            "
            :items="cod_articoli_alt"
            item-text="cod_componente"
            item-value="id_componente"
            label="Cod. Articolo"
            style="
              display: inline-block;
              font-size: 28px;
              font-weight: bold;
              line-height: 35px;
              max-width: 300px;
              padding: 0px;
            "
            v-model="id_articolo_sel"
          >
          </v-autocomplete> -->
          <v-autocomplete
            class="centered-input"
            @change="
              setCodEtichette();
              setCodArticolo();
            "
            :items="cod_articoli_alt"
            item-text="cod_componente"
            return-object
            label="Cod. Articolo"
            style="
              display: inline-block;
              font-size: 28px;
              font-weight: bold;
              line-height: 35px;
              max-width: 300px;
              padding: 0px;
            "
            v-model="obj_art_sel"
          >
          </v-autocomplete>
        </v-col>

        <!-- Spazio per il codice packaging -->
        <v-col cols="6">
          <!-- <v-autocomplete
            @change="setCodPackaging"
            class="centered-input"
            :items="cod_etichette_alt"
            item-text="cod_componente_packaging"
            item-value="id_componente_packaging"
            label="Cod. Packaging"
            style="
              display: inline-block;
              font-size: 28px;
              font-weight: bold;
              line-height: 35px;
              max-width: 300px;
              padding: 0px;
            "
            v-model="id_packaging_alternativo"
          >
          </v-autocomplete> -->
          <v-autocomplete
            @change="setCodPackaging(null)"
            class="centered-input"
            :items="cod_etichette_alt"
            item-text="cod_componente_packaging"
            return-object
            label="Cod. Packaging"
            style="
              display: inline-block;
              font-size: 28px;
              font-weight: bold;
              line-height: 35px;
              max-width: 300px;
              padding: 0px;
            "
            v-model="obj_pack_sel"
          >
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col align="center" cols="12">
          <div class="mr-3" style="display: inline-block">
            <span style="color: black; font-size: 18px">
              Num. Contenitori:
            </span>
          </div>
          <div style="display: inline-block">
            <v-text-field
              class="centered-input"
              hide-details
              label=""
              min="1"
              readonly
              style="
                display: inline-block;
                font-size: 30px;
                font-weight: bold;
                line-height: 35px;
                max-width: 150px;
                padding: 0px;
              "
              type="number"
              v-model="num_contenitori"
            >
            </v-text-field>
          </div>
          <div class="mx-3" style="display: inline-block">
            <span style="color: black; font-size: 18px"
              >Q.tà / contenitore:</span
            >
          </div>
          <div style="display: inline-block">
            <v-text-field
              class="centered-input"
              hide-details
              label=""
              :min="0"
              style="
                display: inline-block;
                font-size: 30px;
                font-weight: bold;
                line-height: 35px;
                max-width: 150px;
                padding: 0px;
              "
              type="number"
              v-model.number="quantita_libera"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- DIALOG CONFERMA -->
    <v-dialog v-model="dialog_conferma_contenitore" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Registrazione
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="confermaSalvataggio()"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogConferma"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 17px">
            Sei veramente sicuro di voler confermare i dati appena inseriti?
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG ETICHETTA -->
    <v-dialog v-model="dialog_preview" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Stampa Etichetta
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="confirmPrint()" small>
                <v-icon color="primary"> mdi-printer </v-icon>
              </v-btn>
            </template>
            <span>Stampa</span>
          </v-tooltip> -->
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogPreview"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-col cols="12">
          <iframe
            :src="iframeUrl"
            frameborder="0"
            style="height: 70vh !important; width: 750px !important"
          >
          </iframe>
        </v-col>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import DataMatrixReader from "../../TOOLS/DataMatrixReader.vue";

class Qrcode {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }
  setCampi() {
    const campi = [
      { nome: "check_seriale", default_val: null },
      { nome: "cod_articolo", default_val: null },
      { nome: "cod_packaging", default_val: "" },
      { nome: "quantita", default_val: null },
      { nome: "seriale", default_val: null },
      { nome: "tipo_etichetta", default_val: null },
    ];
    return campi;
  }
}

export default {
  name: "AvanzaContenitoreAlt",
  components: {
    SnackbarQV,
    DataMatrixReader,
  },
  props: {
    workorder: { type: Object, default: () => {} },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      // Variabili di supporto
      obj_art_sel: null,
      obj_pack_sel: null,
      cod_articolo_sel: null,
      cod_packaging_sel: null,
      id_articolo_sel: null,
      id_packaging_alternativo: null,
      is_magazzino_valid: 0,
      loading: false,
      num_contenitori: 1,
      quantita_libera: 0,
      qr_attivo: false,
      qr_code_sel: new Qrcode(),
      iframeUrl: null,

      // Modal
      dialog_conferma_contenitore: false,
      dialog_preview: false,

      // Array
      cod_articoli_alt: new Array(),
      cod_etichette_alt: new Array(),
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          // Prendo i codici articolo alternativi.
          this.getCodArticoli();

          // Resetto le variabili d'appoggio.
          this.cod_articolo_sel = null;
          this.cod_packaging_sel = null;
          this.id_articolo_sel = null;
          this.id_packaging_alternativo = null;
          this.is_magazzino_valid = 0;
          this.num_contenitori = 1;
          this.obj_art_sel = null;
          this.obj_pack_sel = null;
          this.quantita_libera = 0;
          this.qr_code_sel = new Qrcode();

          this.cod_articoli_alt = new Array();
          this.cod_etichette_alt = new Array();
        }
      },
    },
  },
  methods: {
    async confirmPrint() {
      try {
        this.loading = true;

        const request = {
          controller: "Global",
          method: "POST",
          richiesta: {
            action: "getdispositiviutente",
            token: localStorage.user_token,
          },
        };

        var pName = "";

        await this.$store.dispatch("api", request).then((res) => {
          pName = res.data.result.dispositivi[0].nome_dispositivo;
        });

        // var tempPrintId = 0;
        // if (this.multiPage) {
        //   tempPrintId = this.printIds[this.cPage];
        // } else {
        //   tempPrintId = this.printIds[0];
        // }

        const request2 = {
          controller: "report",
          method: "POST",
          richiesta: {
            action: "getreportpdf",
            token: localStorage.user_token,
            cod_report: "rptArticoloDdt",
            printer_name: pName,
            parametri: [
              {
                parametro: "@cod_articolo",
                valore: this.obj_art_sel.cod_componente,
              },
              {
                parametro: "@cod_articolo_packaging",
                valore: this.obj_pack_sel.cod_componente_packaging,
              },
              {
                parametro: "@id_articolo_packaging",
                valore: "SERIALE",
              },
              {
                parametro: "@quantita",
                valore: this.quantita_libera,
              },
              {
                parametro: "@tipo_etichetta",
                valore: "SLAVE",
              },
            ],
          },
        };

        await this.$store.dispatch("api", request2).then((res) => {
          if (
            "tipo_messaggio" in res.data &&
            "query_messaggio" in res.data &&
            res.data.tipo_messaggio == 1
          ) {
            this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
          }
          this.$refs.SnackbarQV.print("success", "Etichetta stampata");
          this.loading = false;
        });
      } catch (err) {
        this.loading = false;
        if (
          "tipo_messaggio" in err.response.data &&
          "query_messaggio" in err.response.data &&
          err.response.data.tipo_messaggio == 2
        ) {
          this.$refs.SnackbarQV.print(
            "error",
            err.response.data.query_messaggio
          );
        } else {
          this.$refs.SnackbarQV.print("error", err.toString());
        }
      }
    },
    clickSaveQuantitaLibera() {
      this.dialog_conferma_contenitore = true;
    },
    confermaSalvataggio() {
      this.dialog_conferma_contenitore = false;

      if (this.num_contenitori <= 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità dei contenitori deve essere maggiore di 0."
        );
        return;
      }

      if (this.quantita_libera <= 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare la quantità di pezzi per contenitore."
        );
        return;
      }

      /* Controllo che se il WO vuole prelievo componenti, la
       * registrazione non ecceda la quantità realizaabile. */
      if (
        this.num_contenitori * this.quantita_libera >
          this.workorder.qta_realizzabile &&
        this.workorder.materia_prima === 1
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          `I pezzi registrati non possono essere superiori alla quantità realizzabile (${this.workorder.qta_realizzabile} unità). Dichiarare nuovi componenti.`
        );
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_articolo_alternativo: this.id_articolo_sel,
          id_macchina: this.workorder.id_macchina,
          id_commessa_dettaglio: this.workorder.id_commessa_dettaglio,
          id_contenitore: this.id_packaging_alternativo,
          qta_contenitori: this.num_contenitori,
          qta_pezzi: this.quantita_libera,
          seriale: this.qr_code_sel.seriale,
          tipo_avanzamento: 0,
          tipo_etichetta:
            this.qr_code_sel.tipo_etichetta === "MASTER"
              ? 0
              : this.qr_code_sel.tipo_etichetta === "SLAVE"
              ? 1
              : "",
          //registrazione_alternativa: 1,
          id_causale: -98,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$emit("click_salva");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione colserver, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione colserver, non è stato possibile salvare i dati."
          );
        });
    },
    chiudiDialogConferma() {
      this.dialog_conferma_contenitore = false;
      this.num_contenitori = 1;
      this.quantita_libera = 0;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    chiudiDialogPreview() {
      this.dialog_preview = false;
    },
    detectQrCode(arg) {
      // Controllo che il codice contenga il prefisso giusto.
      if (arg.includes("GETQRC") === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (intestazione non valida), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga il cod. articolo giusto.
      if (arg.includes("(P)")) {
        this.qr_code_sel.cod_articolo = arg.split("(P)")[1].split(";")[0];
        if (this.qr_code_sel.cod_articolo != this.cod_articolo_sel) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Il codice articolo dell'etichetta '${this.qr_code_sel.cod_articolo}' non corrisponde al codice articolo che si vuole registrare '${this.cod_articolo_sel}'.`
          );
          return;
        }
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun Cod. Articolo), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga il cod. packaging giusto.
      if (arg.includes("(K)")) {
        this.qr_code_sel.cod_packaging = arg.split("(K)")[1].split(";")[0];
        if (this.qr_code_sel.cod_packaging != this.cod_packaging_sel) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Il codice packaging dell'etichetta '${this.qr_code_sel.cod_packaging}' non corrisponde al contenitore che si vuole registrare '${this.cod_packaging_sel}'.`
          );
          return;
        }
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun Cod. Packaging), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga l'informazione di quantità.
      if (arg.includes("(Q)")) {
        this.qr_code_sel.quantita = arg.split("(Q)")[1].split(";")[0];
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessuna Quantità), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga il tipo etichetta.
      if (arg.includes("(T)")) {
        this.qr_code_sel.tipo_etichetta = arg.split("(T)")[1].split(";")[0];
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun Tipo Etichetta), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga un seriale e che sia un seriale libero.
      if (arg.includes("(S)")) {
        this.qr_code_sel.seriale = arg.split("(S)")[1].split(";")[0];
        if (this.qr_code_sel.seriale != "") {
          this.caricamento = true;
          // chiamata che controlla il seriale
          let request = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
              action: "checknumeroseriale",
              token: localStorage.user_token,
              seriale: this.qr_code_sel.seriale,
            },
          };
          this.$store
            .dispatch("api", request)
            .then((res) => {
              if (res.status === 200) {
                this.caricamento = false;
                this.qr_code_sel.check_seriale =
                  res.data.result[0].seriale_valido;

                this.qr_attivo = true;
                if (this.qr_code_sel.check_seriale == "true") {
                  this.clickSaveQuantitaLibera();
                } else {
                  this.$refs.SnackbarQV.print(
                    "error",
                    `Il seriale risulta già usato da ${
                      res.data.result[0].nominativo
                    } in data ${this.formatData(res.data.result[0].data)}.`
                  );
                }
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Errore di comunicazione col server, non è stato possibile ottenere i dati."
                );
              }
            })
            .catch(() => {
              this.$refs.SnackbarQV.print(
                "error",
                "Errore di comunicazione col server, non è stato possibile ottenere i dati."
              );
            });
        }
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun seriale), impossibile acquisire i dati."
        );
        return;
      }
    },
    formatData(arg) {
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        return strRes;
      }
    },
    getCodArticoli() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolietichette",
          token: localStorage.user_token,
          id_articolo: this.workorder.id_articolo,
          id_commessa: this.workorder.id_commessa,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.articoli.forEach((e) => {
              this.cod_articoli_alt.push(e);
            });

            // Se c'è un solo cod_articolo, seleziono quello in automatico.
            if (this.cod_articoli_alt.length === 1) {
              this.id_articolo_sel = this.cod_articoli_alt[0].id_componente;
              this.obj_art_sel = JSON.parse(
                JSON.stringify(this.cod_articoli_alt[0])
              );
              this.setCodEtichette();
              this.setCodArticolo();
            } else if (this.cod_articoli_alt.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono stati trovati codici articolo alternativi."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          return false;
        });
    },
    handleDataMatrixClick() {
      // Controllo che sia stato selezionato il codice articolo.
      if (this.id_articolo_sel == null || this.id_articolo_sel == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare un Cod. Articolo.");
        return;
      }

      // Controllo che esista il magazzino per l'articolo selezionato.
      if (this.is_magazzino_valid == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Non è presente il magazzino predefinito per l'articolo ${this.cod_articolo_sel}.`
        );
        return;
      }

      // Controllo che sia stato selezionato il codice packaging.
      if (
        this.id_packaging_alternativo == null ||
        this.id_packaging_alternativo == ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare un Cod. Packaging.");
        return;
      }

      // Controllo che il codice alternativo selezionato disponga di codici di packaging validi.
      if (this.id_packaging_alternativo == -1) {
        this.$refs.SnackbarQV.print(
          "orange",
          "L'articolo selezionato non dispone di cod. packaging validi per la registrazione."
        );
        return;
      }

      // Controllo che la quantità sia valida.
      if (
        this.quantita_libera == null ||
        this.quantita_libera == "" ||
        this.quantita_libera === 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità di materiale / contenitore deve essere superiore a 0."
        );
        return;
      }

      // Controllo che la quantità non sia negativa
      if (this.quantita_libera <= 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità del materiale non può essere nulla o negativa."
        );
        return;
      }

      // Controllo che la quantità non sia eccessiva per il Work Order.
      const diff =
        (this.workorder.pezzi_avanzati_fase != null
          ? this.workorder.pezzi_avanzati_fase
          : 0) +
        (this.workorder.pezzi_magazzino != null
          ? this.workorder.pezzi_magazzino
          : 0) +
        (this.quantita_libera != null ? this.quantita_libera : 0);

      if (diff > this.workorder.quantita) {
        this.$refs.SnackbarQV.print(
          "orange",
          `La quantità di materiale è superiore a quella prevista per questo WO di ${parseFloat(
            diff - this.workorder.quantita
          )} unità.`
        );
        return;
      }

      // Se i controlli sono ok, attivo la telecamera.
      this.$refs.qr.attiva_telecamera();
    },
    setCodArticolo() {
      if (this.obj_art_sel != null) {
        this.id_articolo_sel = this.obj_art_sel.id_componente;
      }

      /* Itero l'array dei codici articolo e quando
       * trovo quello giusto prendo da parte il cod_articolo. */
      this.cod_articoli_alt.forEach((e) => {
        if (this.id_articolo_sel == e.id_componente) {
          this.cod_articolo_sel = e.cod_componente;
          this.is_magazzino_valid = e.id_magazzino;
        }
      });
    },
    setCodEtichette() {
      if (this.obj_art_sel != null) {
        this.id_articolo_sel = this.obj_art_sel.id_componente;
      }

      // Resetto l'array delle etichette.
      this.cod_etichette_alt = new Array();

      /* Itero l'array dei codici articolo e quando
       * trovo quello giusto prendo le sue etichette
       * e le inserisco dentro all'array delle etichette. */
      this.cod_articoli_alt.forEach((e) => {
        if (this.id_articolo_sel == e.id_componente) {
          e.packaging.forEach((p) => {
            this.cod_etichette_alt.push(p);
          });
        }
      });

      /* Dato che ho cambiato il codice articolo,
       * resetto il codice etichetta che gli è subordinato.
       * Se è il caso, il dato verrà reinserito fra poco
       * in maniera automatica, o sarà l'utente a selezionarlo.  */
      this.obj_pack_sel = null;
      this.id_packaging_alternativo = null;

      /* Se c'è una sola etichetta selezionabile,
       * la seleziono automaticamente. */
      if (this.cod_etichette_alt.length === 1) {
        this.obj_pack_sel = this.cod_etichette_alt[0];
        this.id_packaging_alternativo =
          this.cod_etichette_alt[0].id_componente_packaging;
        this.setCodPackaging("auto");
      }
    },
    setCodPackaging(arg) {
      if (arg == null) {
        this.id_packaging_alternativo =
          this.obj_pack_sel.id_componente_packaging;
      }

      /* Itero l'array dei codici packaging e quando trovo quello
       * giusto prendo da parte il cod_articolo_packaging selezionato. */
      this.cod_etichette_alt.forEach((e) => {
        if (this.id_packaging_alternativo == e.id_componente_packaging) {
          this.cod_packaging_sel = e.cod_componente_packaging;
          this.obj_pack_sel = e;
        }
      });

      /* Se id_pachaging_alternativo è -1 vuol dire che l'articolo selezionato
       * non dispone di codici packaging dichiarati quindi stampo una snackbar.  */
      if (this.id_packaging_alternativo == -1) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Questo articolo non dispone di cod. packaging selezionabili."
        );
      }
    },
    showPreviewEtichetta() {
      // Controllo che sia stato selezionato il codice articolo.
      if (this.id_articolo_sel == null || this.id_articolo_sel == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare un Cod. Articolo.");
        return;
      }

      // Controllo che sia stato selezionato il codice packaging.
      if (
        this.id_packaging_alternativo == null ||
        this.id_packaging_alternativo == ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare un Cod. Packaging.");
        return;
      } else {
        console.log(this.id_packaging_alternativo);
      }

      if (this.num_contenitori <= 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità dei contenitori deve essere maggiore di 0."
        );
        return;
      }

      // Controllo che la quantità non sia negativa
      if (this.quantita_libera <= 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità del materiale non può essere nulla o negativa."
        );
        return;
      }

      // Controllo che la quantità non sia eccessiva per il Work Order.
      const diff =
        (this.workorder.pezzi_avanzati_fase != null
          ? this.workorder.pezzi_avanzati_fase
          : 0) +
        (this.workorder.pezzi_magazzino != null
          ? this.workorder.pezzi_magazzino
          : 0) +
        (this.quantita_libera != null ? this.quantita_libera : 0);

      if (diff > this.workorder.quantita) {
        this.$refs.SnackbarQV.print(
          "orange",
          `La quantità di materiale è superiore a quella prevista per questo WO di ${parseFloat(
            diff - this.workorder.quantita
          )} unità.`
        );
        return;
      }

      this.loading = true;

      const request0 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getseriale",
          token: localStorage.user_token,
          id_articolo_packaging: this.obj_pack_sel.id_componente_packaging,
        },
      };

      this.$store
        .dispatch("api", request0)
        .then(async (res0) => {
          if (res0.status === 200) {
            const resp = JSON.parse(res0.data.result);

            if (resp.length == 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono state trovate etichette per questo packaging."
              );
              return;
            }

            const request = {
              controller: "Magazzino",
              method: "PUT",
              richiesta: {
                action: "registraestampa",
                token: localStorage.user_token,
                id_articolo_alternativo: this.id_articolo_sel,
                id_macchina: this.workorder.id_macchina,
                id_commessa_dettaglio: this.workorder.id_commessa_dettaglio,
                id_contenitore: this.id_packaging_alternativo,
                qta_contenitori: this.num_contenitori,
                qta_pezzi: this.quantita_libera,
                seriale: this.qr_code_sel.seriale,
                //registrazione_alternativa: 1,
                id_causale: -99,
                nome_parametro_seriale: "@id_articolo_packaging",
                dati_report: {
                  cod_report: "report_singola",
                  parametri: [
                    {
                      parametro: "@cod_articolo",
                      valore: `${this.obj_art_sel.cod_componente}`,
                    },
                    {
                      parametro: "@cod_articolo_packaging",
                      valore: `${this.obj_pack_sel.cod_componente_packaging}`,
                    },
                    {
                      parametro: "@seriale",
                      valore: resp[0].seriale,
                    },
                    // {
                    //   parametro: "@id_articolo_packaging",
                    //   valore: "SERIALE",
                    // },
                    {
                      parametro: "@quantita",
                      valore: this.quantita_libera,
                    },
                    {
                      parametro: "@id_utente",
                      valore: localStorage.id,
                    },
                    {
                      parametro: "@cod_macchina",
                      valore: `${this.workorder.cod_macchina}`,
                    },
                  ],
                },
              },
            };
            this.$store
              .dispatch("api", request)
              .then((res) => {
                if (res.status === 200) {
                  if (
                    "tipo_messaggio" in res.data &&
                    "query_messaggio" in res.data &&
                    res.data.tipo_messaggio == 1
                  ) {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      res.data.query_messaggio
                    );
                  }

                  const response = res.data.result;
                  const byteCharacters = atob(response);
                  const byteNumbers = new Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }
                  const byteArray = new Uint8Array(byteNumbers);
                  const blob = new Blob([byteArray], {
                    type: "application/pdf",
                  });
                  const blobUrl = URL.createObjectURL(blob);
                  this.iframeUrl = blobUrl;
                  this.loading = false;
                  this.dialog_preview = true;
                } else {
                  this.$refs.SnackbarQV.print(
                    "orange",
                    "Invio di stampa non riuscito."
                  );
                }
                this.loading = false;
              })
              .catch((err) => {
                this.loading = false;
                console.error(err);
                if (
                  "tipo_messaggio" in err.response.data &&
                  "query_messaggio" in err.response.data &&
                  err.response.data.tipo_messaggio == 2
                ) {
                  this.$refs.SnackbarQV.print(
                    "error",
                    err.response.data.query_messaggio
                  );
                } else {
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                  );
                }
              });
          } else {
            this.loading = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile ottenere i dati."
            );
          }
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile ottenere i dati."
          );
        });
    },
  },
};
</script>
